<template>
  <section class="course-set">
    <h3 class="course-set-title">{{ $t('course_consist') }}:</h3>
    <ul class="course-set-list">
      <li
        class="course-set-item"
        v-if="course.sostav_val1 && course.sostav_name1"
      >
        <span class="course-set-item__count">{{ course.sostav_val1 }}</span>
        {{ course.sostav_name1 }}
      </li>

      <li
        class="course-set-item"
        v-if="course.sostav_val2 && course.sostav_name2"
      >
        <span class="course-set-item__count">{{ course.sostav_val2 }}</span>
        {{ course.sostav_name2 }}
      </li>

      <li
        class="course-set-item"
        v-if="course.sostav_val3 && course.sostav_name3"
      >
        <span class="course-set-item__count">{{ course.sostav_val3 }}</span>
        {{ course.sostav_name3 }}
      </li>

      <li
        class="course-set-item"
        v-if="course.sostav_val4 && course.sostav_name4"
      >
        <span class="course-set-item__count">{{ course.sostav_val4 }}</span>
        {{ course.sostav_name4 }}
      </li>

      <li
        class="course-set-item"
        v-if="course.sostav_val5 && course.sostav_name5"
      >
        <span class="course-set-item__count">{{ course.sostav_val5 }}</span>
        {{ course.sostav_name5 }}
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'CourseSet',

  props: {
    course: Object
  }
}
</script>

<style scoped>
  .course-set {
    border: 1px solid #e6f0f2;
    border-radius: 6px;
    padding: 20px;
  }
  .course-set-title {
    font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  }
  .course-set-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .course-set-item__count {
    color: #6abe4c;
    font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    font-size: 1.15rem;
  }
</style>
